function compareTag(element, tagName) {
    return element.tagName.toLowerCase() === tagName.toLowerCase();
}

export { compareTag };
//# sourceMappingURL=compareTag.js.map
